import React from 'react';
import { QuizHome, SEO } from '../../components';
import { graphql } from 'gatsby';
import './process.css';

function QuizPage() {
  return (
    <main id='quiz-page'>
      <QuizHome />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Can I get Laser Hair Removal? | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description="Wondering if you're a good candidate for laser hair removal? Take our short laser hair removal quiz to find out if it's the right solution for you."
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default QuizPage;
